// extracted by mini-css-extract-plugin
export var companyNavHolder = "CompanyNav-module--companyNavHolder--9a087";